import * as React from "react"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import FindClimb from "./pages/findClimb"
import ShowClimb from "./pages/ShowClimb"
import SearchClimbs from "./pages/SearchClimbs"
import Home from "./pages/Home"
import Graph from "./pages/graph"
import Admin from "./admin/pages/Admin"
import Stats from "./pages/stats"
import Stream from "./pages/Stream"
import Project from "./pages/Project"
import Layout from "./components/Layout"
import { QueryClient, QueryClientProvider } from "react-query"

// Create a client
const queryClient = new QueryClient()

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/find-climb" element={<FindClimb />} />
            <Route path="/search-climbs" element={<SearchClimbs />} />
            <Route path="/climb/:climbId" element={<ShowClimb />} />
            <Route path="/graph" element={<Graph />} />
            <Route path="/stats" element={<Stats />} />
            <Route path="/stream" element={<Stream />} />
            <Route path="/project" element={<Project />} />
          </Routes>
        </Layout>
      </Router>
    </QueryClientProvider>
  )
}
